import format from "date-fns/format";
import { enUS } from "date-fns/locale";

export function fnsFormatDate(date: Date, formatStr = "MM/dd/yyyy"): string {
  return format(date, formatStr, { locale: enUS });
}
